// extracted by mini-css-extract-plugin
export default {"main":"_7577c52d88","tit":"_8d6c925423","maintitle":"_6d4d2d7c45","ylw":"c8238c1688","white":"_29e278285a","mv_title":"faccfb05f8","mv_nc":"f2b5042207","mv_in":"_133307642d"};